import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';
import OverLimitPriceViewTable from '../tables/OverLimitPriceViewTable';
import { REQUEST_SELLING_PRICE_LIMIT } from '../../utils/constants/threshold';

const OverLimitPriceModal = ({ isShow, onClose, modalData }) => {
    const { t } = useTranslation();
    return (
        <Modal
            size="xl"
            isShow={isShow}
            onClose={onClose}
            isShowIconClose="true"
            title={t('modal.common_modal.title')}
            btnList={[
                {
                    name: 'OK',
                    className: 'btn--primary',
                    onClick: onClose,
                    disabled: false,
                },
            ]}
            children={
                <>
                    <p className="text-center">{`売価が${REQUEST_SELLING_PRICE_LIMIT.toLocaleString()}円を超えている商品があります。`}</p>
                    <p className="text-center">登録に誤りがないか確認し、削除または修正をしてください。</p>
                    <OverLimitPriceViewTable dataTable={modalData} />
                </>
            }
        />
    );
};

export default OverLimitPriceModal;
